import { Input } from "@heroui/react";
import React, { ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export interface ISearchboxInputProps {
    setSearchTerm: (value: string) => void;
}
const SearchboxInput: React.FC<ISearchboxInputProps> = ({ setSearchTerm }) => {
    return (
        <Input size='sm'
            classNames={{
                inputWrapper: 'rounded',
            }}
            isClearable
            placeholder="Search..."
            startContent={<FontAwesomeIcon size='sm' icon={faSearch} />}
            onClear={() => setSearchTerm('')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
        />
    );
};

export default SearchboxInput;